import { withAuthGate } from '@sunrise-ui/composites';
import {
  PageContainer,
  useSafeLocalSearchParams,
} from '@sunrise-ui/primitives';
import GroupPurchaseView from '@templates/GroupPurchaseView';
import React from 'react';

function GroupPurchasePage() {
  const { slug } = useSafeLocalSearchParams<{
    slug: string;
  }>();

  return (
    <PageContainer>
      <GroupPurchaseView slug={slug} />
    </PageContainer>
  );
}

export default withAuthGate(GroupPurchasePage);
